import React, {FC} from "react";
import ButtonSecondary from "../../components/Button/ButtonSecondary";
import {ArrowRightIcon} from "@heroicons/react/solid";

export interface SectionBlog {
    className?: string;
    rightImg?: string;
}

const SectionBlog: FC<SectionBlog> = ({
                                          className = "",
                                      }) => {
    return (
        <div
            className={`text-center justify-center SectionBlog relative flex flex-col lg:flex-row items-center  ${className}`}
            data-id="SectionBlog"
        >
            <div className="text-center justify-center flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
                <h2 className="font-semibold text-3xl sm:text-4xl mt-3">
                    Take fate into your own hands.
                </h2>
                <span className="justify-center block mt-8 text-neutral-500 dark:text-neutral-400">
                                Engage with the latest Web3 community & stay up to date with current decentralised technologies here at The CryptoVerse.
        </span>
                <div className="flex space-x-4 mt-1 justify-center py-10">
                    <ButtonSecondary href={"/dashboard/submit-post"}>Publish An Article<ArrowRightIcon className="w-5 h-5 ml-2"/>
                    </ButtonSecondary>
                </div>
            </div>
        </div>
    );
};

export default SectionBlog;

